export const structureId = () => Array.from({ length: 24 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
